// ⚠️ 此文件由 api:gen 自动生成，请勿手动修改
// 源: capabilities/questionnaire.yaml
// 生成时间: 2026-09-09T10:41:27.313Z
import http from '../http';

export default {
  // 获取列表 questionnaire.list
  list: (data) => http.post('formbuilder/form/page', data),

  // 新增和更新问卷。无 id 为新增；传入已有 id 为更新（更新须传完整对象，缺失字段会被覆盖/清空）。【入参硬性要求，违反即为错误调用】① contentArry 中每一道题都必须显式携带 testType 与 testExpress 两个字段，类型 string；不需要格式校验时固定传空字符串 ""。严禁省略、严禁传 null——该字段落库为 null 会导致下游业务流程报错。② 所有声明为 object / array 的字段（basic、css、markProt、data、submitAfter、shareContent、subButton、contentStyle、explain.img 等）若不使用，一律传空对象 {} 或空数组 []，严禁传 null。③ 此要求与题型无关，与是否必填(required)无关，不因"该题型用不上校验"而豁免。 questionnaire.save
  save: (data) => http.post('formbuilder/form/save', data),

  // 获取单个问卷 questionnaire.get
  get: (data) => http.post('formbuilder/form/get', data),

  // 删除 questionnaire.delete
  delete: (data) => http.post('formbuilder/form/delete', data),

  // 导出收集的数据 questionnaire.exportData
  exportData: (data) => http.post('formbuilder/userform/export', data),

  // 导出收集的数据 questionnaire.exportDataWithNum
  exportDataWithNum: (data) => http.post('formbuilder/userform/export/with', data),

  // 导出全部数据 questionnaire.exportAll
  exportAll: (data) => http.post('formbuilder/userform/batchexport', data),

  // 获取问卷收集数据图表分析 questionnaire.collectionChat
  collectionChat: (data) => http.post('formbuilder/form/count', data),

  // 获取问卷收集数据 questionnaire.collectionData
  collectionData: (data) => http.post('formbuilder/userform/pagedetail', data),

  // 获取问卷某一题目的所有答案 questionnaire.collectionQuestionData
  collectionQuestionData: (data) => http.post('formbuilder/form/pageAnswer', data),
};
